import React from 'react';
import BannerAdUnit from '../AdUnit/Banner';
import { STUDIO_PRODUCTS_CATALOG_CARD_D_REAL_ESTATE_ID } from '../constants';

export interface Props {}

const StudioProductsCatalogCardD: React.FC<Props> = () => (
  <BannerAdUnit
    width="306px"
    height="314px"
    realEstateId={STUDIO_PRODUCTS_CATALOG_CARD_D_REAL_ESTATE_ID}
  />
);
StudioProductsCatalogCardD.displayName = 'StudioProductsCatalogCardD';

export default StudioProductsCatalogCardD;
